<div class="flex-fill d-flex flex-row">
  @if (!showAsDialog) {
    <div class="flex-shrink-0 sidebar">
      <div class="toolbar m-3">
        @if (!hasChanges()) {
          <dx-button text="Close" type="default" accessKey="c" (onClick)="close()"></dx-button>
        }
        @if (hasChanges()) {
          <dx-button text="Save" type="success" accessKey="s" (onClick)="save()"></dx-button>
        }
        @if (hasChanges()) {
          <dx-button text="Cancel" type="danger" (onClick)="cancel()"></dx-button>
        }
      </div>
      <div class="border-top m-3"></div>
      <div class="toolbar m-3">
        <button [disabled]="hasChanges()" class="btn btn-small btn-primary" (click)="openStatement()">Generate Statement</button>
      </div>
      <div class="toolbar m-3">
        <button [disabled]="hasChanges()" class="btn btn-small btn-primary" (click)="openInvoicesReport()">Open Invoices Report</button>
      </div>
      <div class="toolbar m-3">
        <button [disabled]="hasChanges()" class="btn btn-small btn-primary" (click)="emailOpenInvoicesReport()">Email Open Invoices</button>
      </div>
    </div>
  }
  <div class="flex-fill" style="width: 1px">
    @if (customer) {
      <div [class]="!showAsDialog ? 'content-block dx-card responsive-paddings' : ''" autofocus>
        @if (customer) {
          <dx-form [formData]="customer" [validationGroup]="'customerValidationGroup'" appAutofocusForm>
            <dxi-form-item itemType="tabbed">
              <dxi-form-tab [title]="'Customer'" class="p-0">
                <dxi-form-item itemType="group" [colCount]="2">
                  <dxi-form-item
                    dataField="typeId"
                    [label]="{ text: 'Customer Type' }"
                    [editorType]="'dxSelectBox'"
                    [editorOptions]="{ dataSource: customerTypes, displayExpr: 'name', valueExpr: 'id' }"
                    >
                    <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                  </dxi-form-item>
                  <dxi-form-item
                    dataField="salesPersonId"
                    [label]="{ text: 'Sales Person' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: salesPersons, displayExpr: 'name', valueExpr: 'id' }"
                  ></dxi-form-item>
                  <dxi-form-item dataField="companyName"></dxi-form-item>
                  <dxi-form-item dataField="quickBooksId" [label]="{ text: 'GreatPlains Id' }"></dxi-form-item>
                  <dxi-form-item dataField="firstName"></dxi-form-item>
                  <dxi-form-item dataField="nameOverride" [label]="{ text: 'Scheduling Name Override' }"></dxi-form-item>
                  <dxi-form-item dataField="lastName"></dxi-form-item>
                  <dxi-form-item itemType="empty"></dxi-form-item>
                  <dxi-form-item
                    dataField="preferredCommunication"
                    [label]="{ text: 'Preferred Communication' }"
                    [editorType]="'dxSelectBox'"
                    [editorOptions]="{ dataSource: communicationOptions }"
                    >
                  </dxi-form-item>
                  <dxi-form-item dataField="phone"></dxi-form-item>
                  <dxi-form-item dataField="email"></dxi-form-item>
                </dxi-form-item>
                <dxi-form-item>
                  <div *dxTemplate>
                    <button class="btn btn-primary" (click)="addNote()" [disabled]="key === 'new'">Add Note</button>
                  </div>
                </dxi-form-item>
                <dxi-form-item itemType="group" [colCount]="2">
                  <dxi-form-item [label]="{ text: 'Customer Notes' }">
                    <div *dxTemplate>
                      <ul style="list-style-type: none; padding-inline-start: 0px">
                        @for (note of customer.customerNotes; track note) {
                          <li>
                            <a title="edit" (click)="editNote(note)"> <i class="fa fa-pencil" aria-hidden="true"></i> </a
                            >&nbsp;
                            <a title="remove" (click)="removeNote(note)"> <i class="fa fa-times" aria-hidden="true"></i> </a
                            >&nbsp;
                            {{ note.display }}
                          </li>
                        }
                      </ul>
                    </div>
                  </dxi-form-item>
                  <dxi-form-item
                    dataField="siteNotes"
                    [label]="{ text: 'Site Notes' }"
                    editorType="dxTextArea"
                    [editorOptions]="{ readOnly: true, height: '225px' }"
                    >
                  </dxi-form-item>
                </dxi-form-item>
              </dxi-form-tab>
              <dxi-form-tab [title]="'Billing Info'">
                <dxi-form-item itemType="group" [colCount]="3">
                  <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item
                      dataField="billingType"
                      [label]="{ text: 'Billing Type' }"
                      [editorType]="'dxSelectBox'"
                      [editorOptions]="{ dataSource: billingTypeOptions }"
                      >
                    </dxi-form-item>
                    <dxi-form-item
                      dataField="creditCardId"
                      [label]="{ text: 'Credit Card' }"
                      [editorType]="'dxSelectBox'"
                      [editorOptions]="{ dataSource: creditCards, displayExpr: 'name', valueExpr: 'id' }"
                      >
                    </dxi-form-item>
                  </dxi-form-item>
                  <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item dataField="standardRentalLength" [label]="{ text: 'Standard Rental Length' }"> </dxi-form-item>
                    <dxi-form-item
                      dataField="extensionRate"
                      editorType="dxNumberBox"
                      [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                    ></dxi-form-item>
                  </dxi-form-item>
                  <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item
                      dataField="paymentTerms"
                      [label]="{ text: 'Payment Terms' }"
                      [editorType]="'dxSelectBox'"
                      [editorOptions]="{ dataSource: paymentTermOptions }"
                      >
                    </dxi-form-item>
                    <dxi-form-item
                      dataField="billingRule"
                      [label]="{ text: 'Billing Rules (*if blank, bill as customer type)' }"
                      [editorType]="'dxSelectBox'"
                      [editorOptions]="{ items: billingRules }"
                      >
                    </dxi-form-item>
                  </dxi-form-item>
                  <!-- <dxi-item itemType="empty"></dxi-item> -->
                  <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item
                      dataField="billingSameAsService"
                      cssClass="show-labels"
                      [label]="{ text: 'Billing Address Same As Service', location: 'left' }"
                      [editorType]="'dxCheckBox'"
                      >
                    </dxi-form-item>
                    <dxi-form-item
                      dataField="bypassKentCharge"
                      cssClass="show-labels"
                      [label]="{ text: 'County Bypass', location: 'left' }"
                      [editorType]="'dxCheckBox'"
                      >
                    </dxi-form-item>
                    <dxi-form-item [label]="{ text: 'Address Lookup' }" [colSpan]="2">
                      <div *dxTemplate>
                        <app-address-lookup (onLocationChanged)="locationChanged($event)"></app-address-lookup>
                      </div>
                    </dxi-form-item>
                    <dxi-form-item dataField="billAddress1" [label]="{ text: 'Address 1' }"></dxi-form-item>
                    <dxi-form-item dataField="billAddress2" [label]="{ text: 'Address 2' }"></dxi-form-item>
                    <dxi-form-item dataField="billCity" [label]="{ text: 'City' }"></dxi-form-item>
                    <dxi-form-item dataField="billState" [label]="{ text: 'State' }"></dxi-form-item>
                    <dxi-form-item dataField="billZip" [label]="{ text: 'Zip' }"></dxi-form-item>
                    <dxi-form-item dataField="billCountry" [label]="{ text: 'Country' }"></dxi-form-item>
                  </dxi-form-item>
                  <dxi-form-item itemType="group" [colCount]="2">
                    <dxi-form-item
                      dataField="usePercentageBasedFuelRate"
                      cssClass="show-labels"
                      [label]="{ text: 'Use Percentage Based Fuel Rate', location: 'left' }"
                      [editorType]="'dxCheckBox'"
                    ></dxi-form-item>
                    <dxi-form-item
                      dataField="fuelRate"
                      editorType="dxNumberBox"
                      [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                    ></dxi-form-item>
                    <dxi-form-item
                      dataField="hasUniqueRates"
                      cssClass="show-labels"
                      [label]="{ text: 'Has Unique Rate', location: 'left' }"
                      [editorType]="'dxCheckBox'"
                    ></dxi-form-item>
                  </dxi-form-item>
                  <dxi-form-item
                    dataField="balance"
                    editorType="dxNumberBox"
                    [editorOptions]="{ format: { type: 'currency', precision: 2 }, disabled: true }"
                  ></dxi-form-item>
                </dxi-form-item>
              </dxi-form-tab>
              <dxi-form-tab [title]="'Service Address'">
                <app-service-address-overview [customerId]="customer.id" [readonly]="key === 'new'"></app-service-address-overview>
              </dxi-form-tab>
              <dxi-form-tab [title]="'Rates'">
                <div class="d-flex flex-fill flex-column">
                  <dx-data-grid
                    #ratesGrid
                    keyExpr="id"
                    class="d-flex flex-fill flex-column"
                    [dataSource]="rates"
                    [showBorders]="true"
                    style="min-height: 650px"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowDblClick)="rateDoubleClick($event)"
                    >
                    <dxi-data-grid-column dataField="rateType.name" caption="Type" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="dumpsterSize"
                      caption="Size"
                      width="100"
                      [sortIndex]="1"
                      [sortOrder]="'asc'"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="rate" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="pricePerTon"
                      caption="Price/Ton"
                      width="100"
                      [format]="{ type: 'currency', precision: 2 }"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="weightLimit" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="rangeDisplay"
                      caption="Range"
                      width="100"
                      [sortIndex]="2"
                      [sortOrder]="'desc'"
                    ></dxi-data-grid-column>
                    <!-- <dxi-column dataField="zone" width="100" [sortIndex]="3" [sortOrder]="'desc'"></dxi-column> -->
                    <dxi-data-grid-column dataField="baseMileage" caption="Base Mileage" width="125"></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="mileageOffsetRate"
                      caption="$/mi extra"
                      width="125"
                      [format]="{ type: 'currency', precision: 2 }"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="mileageOffset" caption="Additional Miles" width="125"></dxi-data-grid-column>
                    <dxi-data-grid-column></dxi-data-grid-column>
                    <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
                    <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
                    <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                      @if (key !== 'new') {
                        <span>
                          <button class="btn btn-success" (click)="addRate()">Add</button>
                          <button
                            class="btn btn-primary ms-2"
                            (click)="addRate(ratesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="ratesGrid.instance.getSelectedRowsData().length !== 1"
                            >
                            Edit
                          </button>
                          <button
                            class="btn btn-danger ms-2"
                            (click)="deleteRate(ratesGrid.instance.getSelectedRowsData())"
                            [disabled]="ratesGrid.instance.getSelectedRowsData().length !== 1"
                            >
                            Delete
                          </button>
                        </span>
                      }
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                      @if (rates) {
                        <span class="me-3">
                          <strong>{{ ratesGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                      }
                    </div>
                  </dx-data-grid>
                </div>
              </dxi-form-tab>
              <dxi-form-tab [title]="'Rentals'">
                <div class="d-flex flex-fill">
                  <dx-data-grid
                    #searchGrid
                    keyExpr="id"
                    class="d-flex flex-fill flex-column"
                    [dataSource]="rentals"
                    [height]="'650px'"
                    [showBorders]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    >
                    <dxi-data-grid-column dataField="id" width="80" cellTemplate="rentalTemplate"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="displayAddress" caption="Site Address" width="400"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="startDate" dataType="date" format="M/d/yyyy" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="endDate" dataType="date" format="M/d/yyyy" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="preferredTime" dataType="datetime" format="shortTime" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="preferredWindow" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="completed" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="margin" width="100" [format]="{ type: 'percent', precision: 2 }"></dxi-data-grid-column>
                    <dxi-data-grid-column></dxi-data-grid-column>
                    <div *dxTemplate="let cell of 'rentalTemplate'">
                      @if (cell) {
                        <a [routerLink]="'/rentals/' + cell.data.id" [innerHtml]="cell.text"></a>
                      }
                    </div>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                      <button
                        class="btn btn-sm btn-secondary mb-2"
                        (click)="unCompleteRental(searchGrid.instance.getSelectedRowsData()[0])"
                                        [disabled]="
                                            searchGrid.instance.getSelectedRowsData().length !== 1 ||
                                            !searchGrid.instance.getSelectedRowsData()[0].completed
                                        "
                        >
                        UnComplete
                      </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                      @if (customer.rentals) {
                        <span class="me-3">
                          <strong>{{ searchGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                      }
                    </div>
                    <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                    <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
                    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                  </dx-data-grid>
                </div>
              </dxi-form-tab>
              <dxi-form-tab [title]="'Invoices'">
                <div class="d-flex flex-column flex-fill p-1">
                  <dx-data-grid
                    #invoicesGrid
                    keyExpr="id"
                    class="flex-fill d-flex flex-column"
                    height="650px"
                    [dataSource]="invoices"
                    [showBorders]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowDblClick)="invoiceDoubleClick($event)"
                    [columnAutoWidth]="false"
                    >
                    <dxi-data-grid-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="invoiceNumber"
                      caption="Invoice #"
                      width="75"
                      cellTemplate="invoiceLinkTemplate"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column
                      dataField="rentalIdDisplay"
                      caption="Rental"
                      width="75"
                      cellTemplate="rentalLinkTemplate"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="status.name" caption="Status" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="createDate" caption="Created" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="sent" format="shortDate" caption="Sent" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="paid" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="deleted" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="isDeleted" width="75"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="displayServiceAddress" caption="Service Address"></dxi-data-grid-column>
                    <div *dxTemplate="let cell of 'rentalLinkTemplate'">
                      @if (cell) {
                        <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
                      }
                    </div>
                    <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                      @if (cell) {
                        <a [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
                      }
                    </div>
                    <dxo-data-grid-summary>
                      <dxi-data-grid-total-item column="total" summaryType="sum" valueFormat="currency"> </dxi-data-grid-total-item>
                    </dxo-data-grid-summary>
                    <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
                    <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
                    <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                    <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                    <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
                    <dxo-data-grid-state-storing
                      [enabled]="true"
                      type="localStorage"
                      storageKey="customer-invoice-overview-grid"
                    ></dxo-data-grid-state-storing>
                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'toolbarText'">
                      @if (invoices) {
                        <span class="me-3">
                          <strong>{{ invoicesGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                      }
                    </div>
                  </dx-data-grid>
                </div>
              </dxi-form-tab>
            </dxi-form-item>
          </dx-form>
        }
      </div>
    }
  </div>
</div>
